import { adminActionTypes } from "src/action_types/section_action_types";

export function selectedUserTablePageNumberReducer(state = 0, action) {
  switch (action.type) {
    case adminActionTypes.selectUserTablePageNumber:
      return action.payload.pageNumber;
    case adminActionTypes.selectOrganizations:
      return 0;
    case adminActionTypes.deselectOrganizations:
      return 0;
    case adminActionTypes.selectFacilities:
      return 0;
    case adminActionTypes.deselectFacilities:
      return 0;
    case adminActionTypes.selectedPartner:
      return 0;
    case adminActionTypes.selectUserTablePageLimit:
      return 0;
    default:
      return state;
  }
}
